"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractAddress = exports.walletAddress = exports.ethAddress = void 0;
/**
* Type guard for ethereum address strings.
* Converts the string to lowercase then validates the length and prefix.
* Throws if the provided string is the wrong length or does not start with 0x.
*/
function ethAddress(address) {
    const laddress = address.toLowerCase();
    if (!laddress.startsWith('0x') || laddress.length !== 42) {
        throw new Error(`Invalid contract address: ${address}`);
    }
    return laddress;
}
exports.ethAddress = ethAddress;
/** Just like ethAddress but returns a WalletAddress type (identical format, more specific use-case) */
function walletAddress(address) {
    return ethAddress(address);
}
exports.walletAddress = walletAddress;
/** Just like ethAddress but returns a ContractAddress type (identical format, more specific use-case) */
function contractAddress(address) {
    return ethAddress(address);
}
exports.contractAddress = contractAddress;
//# sourceMappingURL=Ether.js.map